//@ts-nocheck
//to strongly type inject/provide define them here using injection keys

export const UNMapActionsKey: InjectionKey<UNMapActions> = Symbol('UNMapActionsKey');